/**
 * Convert known third-party stylesheets to non-blocking once injected into <head>.
 * Targets Loop, Judge.me, and Shopify portable-wallet CSS that Lighthouse flags.
 */
(function () {
  const PATTERNS = [
    /loop_widget\.css/i,
    /accelerated-checkout-backwards-compat\.css/i,
    /judgeme.*\.css/i,
    /shopify_v2\.css/i,
    /widget_v3_base\.css/i
  ];

  function shouldDefer(href) {
    if (!href) return false;
    return PATTERNS.some((re) => re.test(href));
  }

  function deferLink(link) {
    if (!link || link.tagName !== 'LINK') return;
    if (link.rel !== 'stylesheet') return;
    if (link.dataset.mobDeferred === 'true') return;
    if (!shouldDefer(link.href)) return;
    if (link.media && link.media !== 'all' && link.media !== '') return;

    link.dataset.mobDeferred = 'true';
    link.media = 'print';
    link.onload = function () {
      this.media = 'all';
      this.onload = null;
    };
    // Fallback if already loaded
    if (link.sheet) {
      link.media = 'all';
    }
  }

  document.querySelectorAll('link[rel="stylesheet"]').forEach(deferLink);

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType !== 1) return;
        if (node.tagName === 'LINK') deferLink(node);
        else if (node.querySelectorAll) {
          node.querySelectorAll('link[rel="stylesheet"]').forEach(deferLink);
        }
      });
    });
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
